/*
 * @Description: 
 * @Author: 李方强
 * @Date: 2019-10-14 19:40:15
 * @LastEditTime: 2019-11-05 14:30:29
 * @LastEditors: wk
 */
export default [
  {
    path: '/addAfterSales',
    name: '/addAfterSales',
    meta: {
      title: '申请售后'
    },
    component: () => import(/* webpackChunkName: "example-aboult" */ '../views/invoices/voucher/addAfterSales.vue')
  }, {
    path: '/addCompensation',
    name: '/addCompensation',
    meta: {
      title: '申请补偿'
    },
    component: () => import(/* webpackChunkName: "example-aboult" */ '../views/invoices/voucher/addCompensation.vue')
  }
]
